import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { InternationalSizeGuideContainer } from '@domains/pdp-common';

import { OverseasDirectPurchaseSizeGuide } from '../components/overseas-direct-purchase/OverseasDirectPurchaseSizeGuide';
import { useLegacySizeInfoService } from '../services/useLegacySizeInfoService';
import { LegacyActualSizeContainer } from './LegacyActualSizeContainer';
import { LegacyAiCropSizeContainer } from './LegacyAiCropSizeContainer';

export const LegacySizeInfoContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { hideActualSize, hideAiCropSize, hideSizeGuide, hideOverseas, active_tab, tab_list, table_list, onClickTab } =
    useLegacySizeInfoService();

  return (
    <Container>
      {hideActualSize ? null : <LegacyActualSizeContainer />}
      {hideAiCropSize ? null : <LegacyAiCropSizeContainer />}
      {hideOverseas ? null : (
        <OverseasDirectPurchaseSizeGuide
          active_tab={active_tab}
          tab_list={tab_list}
          table_list={table_list}
          onClickTab={onClickTab}
        />
      )}
      {hideSizeGuide ? null : (
        <StyledSizeGuide>
          <InternationalSizeGuideContainer />
        </StyledSizeGuide>
      )}
    </Container>
  );
};

const Container = styled.div`
  margin-bottom: 64px;
  background-color: ${vars.v3Color.gray100};
  touch-action: pan-y;
`;

const StyledSizeGuide = styled.div`
  padding: 20px 16px 40px;
  background-color: ${vars.v3Color.staticWhite};
`;
